<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="left"
          status-icon
          :inline-message="true"
          label-width="auto"
        >
          <el-form-item label="用户姓名：" prop="name">
            <el-input v-model="form.name" size="small" placeholder="用户姓名" />
          </el-form-item>
          <el-form-item label="联系电话：" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="联系电话"
              size="small"
            />
          </el-form-item>
          <el-form-item prop="code">
            <el-col :span="13">
              <el-input
                clearable
                v-model="form.code"
                :autosize="true"
                placeholder="验证码"
                size="small"
                prefix-icon="iconfont icon-anquan1"
              />
            </el-col>
            <el-col :span="10">
              <el-button
                size="mini"
                type="primary"
                :disabled="btn"
                style="margin-left:5px;margin-top:2px;"
                @click="sendCode()"
              >
                {{ msg }}
              </el-button>
            </el-col>
          </el-form-item>
          <el-form-item>
            <router-link :to="{ path: '/user' }">
              <el-button
                size="mini"
                type="primary"
                @click="registrationOrCancellation(2)"
              >
                注销
              </el-button>
            </router-link>
            <el-button
              size="mini"
              type="primary"
              @click="registrationOrCancellation(0)"
            >
              注册
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
  import formRules from "@/utils/formRules.js";
  import { sendCode, registrationOrCancellation } from "@/api/app/weixin";
  export default {
    data() {
      return {
        btn: false,
        msg: "获取验证码",
        form: {
          name: "",
          code: "",
          phone: "",
          openId: this.$route.query.code,
        },
        rules: {
          name: [
            { required: true, message: "请输入姓名", trigger: "blur" },
            {
              min: 2,
              max: 10,
              message: "长度在 2 到 10 个字符",
              trigger: "blur",
            },
          ],
          phone: [
            { required: true, message: "联系电话不能为空" },
            { validator: formRules.validatePhone, trigger: "blur" },
          ],
        },
      };
    },
    created() {
      this.$store.dispatch("getConfig");
    },
    methods: {
      // 用户信息
      registrationOrCancellation(status) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.form.status = status;
            registrationOrCancellation(this.form)
              .then((res) => {
                if (res.code == 200) {
                  this.$notify({ type: "success", message: "操作成功！" });
                }
              })
              .catch((error) => {});
          }
        });
      },
      sendCode() {
        if (this.form.phone) {
          sendCode(this.form.phone).then((res) => {
            console.info(JSON.stringify(res));
          });
          this.btn = true;
          var num = 60;
          var thar = this;
          var timer = setInterval(function() {
            num--;
            thar.msg = num + "秒后重新获取";
            if (num === 0) {
              thar.msg = "获取验证码";
              thar.btn = false;
              clearInterval(timer);
            }
          }, 1000);
        } else {
          this.$notify({ type: "success", message: "手机号码不能为空！" });
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .bg {
    min-height: 100vh;
    background-color: #f0f0f0;
  }
  .content {
    padding: 10px;
    /deep/ .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-form-item {
      margin: 0;
      padding-bottom: 5px;
    }
    /deep/ .el-form-item__content {
      line-height: unset;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 90px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }
    .avatar {
      width: 90px;
      height: 90px;
      display: block;
    }
  }
</style>
